import cn from 'classnames';
import { forwardRef, useCallback } from 'react';

import styles from './gradient-button.module.css';

const GradientButton = forwardRef(
  ({ children, as, className, size = 'md', disabled, hoverless = false, ...rest }, ref) => {
    const Element = as || 'button';

    const handleClick = useCallback(
      e => {
        if (disabled) {
          e.preventDefault();
          e.stopPropagation();
        } else {
          rest.onClick?.(e);
        }
      },
      [disabled, rest.onClick]
    );

    return (
      <Element
        className={cn(
          styles.gradient__button,
          {
            [styles['size-sm']]: size === 'sm',
            [styles['size-md']]: size === 'md',
            [styles['size-lg']]: size === 'lg',
            [styles.disabled]: disabled
          },
          'relative inline-flex items-center font-medium justify-center shrink-0 overflow-hidden text-white transition duration-200 ease-in-out bg-transparent',
          { 'hover:border-white hover:bg-white hover:text-black': !disabled && !hoverless },
          className
        )}
        {...rest}
        disabled={disabled}
        onClick={handleClick}
        ref={ref}
      >
        <span
          className={cn(
            'flex items-center justify-center w-full h-full px-6 duration-200 ease-in-out bg-black transition',
            { 'hover:bg-white hover:text-black': !disabled && !hoverless }
          )}
        >
          {children}
        </span>
      </Element>
    );
  }
);

export default GradientButton;
